module.exports = __webpack_public_path__ + "prod/1.42.2/img/system-one.cbfc9424.png";